import { AxiosHeaders, RawAxiosRequestHeaders } from 'axios';

import { generateBearer } from '@hsp/utilities';

export class HttpHeaders {
  private axiosHeaders: AxiosHeaders;

  constructor(headers?: RawAxiosRequestHeaders | AxiosHeaders) {
    this.axiosHeaders = new AxiosHeaders({ ...headers } as AxiosHeaders);
  }

  get headers() {
    return this.axiosHeaders;
  }

  addAuthentication(token: string) {
    return this.addHeader({ name: 'Authorization', value: generateBearer(token) });
  }

  addHeader(...nameValue: { name: string; value: string }[]) {
    for (const { name, value } of nameValue) {
      this.axiosHeaders.set(name, value);
    }

    return this;
  }
}

// export const addAuthentication = (token: string, headers?: RawAxiosRequestHeaders | AxiosHeaders) => {
//   return addHttpHeader(headers, { name: 'Authorization', value: generateBearer(token) });
// };

// export const addHttpHeader = (
//   headers?: RawAxiosRequestHeaders | AxiosHeaders,
//   ...nameValue: { name: string; value: string }[]
// ) => {
//   headers = buildHttpHeaders(headers);

//   for (const { name, value } of nameValue) {
//     headers.set(name, value);
//   }

//   return headers;
// };

// export const buildHttpHeaders = (headers?: RawAxiosRequestHeaders | AxiosHeaders) => {
//   return new AxiosHeaders({ ...headers } as AxiosHeaders);
// };
